/**
 * Guided tour for the Punch Lists list view (``PunchListsPage``).
 *
 * This tour runs *only* for users who have no items yet — it introduces
 * the page so they know how to create one. Users with items at least one
 * existing punch list item see the {@link combined.ts | combined tour}
 * instead, which chains the list view into the detail view.
 *
 * Importing this module registers the tour as a side effect.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  filtersStep,
  listTableStep,
  newItemStep,
  statusChartStep,
} from './steps';

export const PUNCH_LISTS_LIST_TOUR_ID = 'punch_lists.list';

registerTour({
  id: PUNCH_LISTS_LIST_TOUR_ID,
  name: 'Punch Lists',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.PUNCH_LISTS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Punch Lists',
      body:
        'Track outstanding work and quality issues across your project — ' +
        'defects, follow-ups, anything that needs to be closed out.',
    },
    newItemStep,
    statusChartStep,
    filtersStep,
    listTableStep,
  ],
});
